import validate from "H:/ssd2/vkusilosos-web-main/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "H:/ssd2/vkusilosos-web-main/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-category-dish-route": () => import("H:/ssd2/vkusilosos-web-main/middleware/check-category-dish-route.ts"),
  "check-category-route": () => import("H:/ssd2/vkusilosos-web-main/middleware/check-category-route.ts")
}